// ======================================================================
// File Name       : FunctionSuperuserAuthConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { HIDDEN_STATUS } from './EnterpriseConstants';
import * as FUNCTION from './FunctionConstants';
import { READ, WRITE } from './index';

const ENTERPRISE_MANAGEMENT_READ = [FUNCTION.ENTERPRISE_LIST, FUNCTION.ENTERPRISE_DETAIL];
const ENTERPRISE_MANAGEMENT_WRITE = [
  ...ENTERPRISE_MANAGEMENT_READ,
  FUNCTION.ENTERPRISE_REGISTER,
  FUNCTION.ENTERPRISE_EDIT,
  FUNCTION.ENTERPRISE_IMPORT,
];

const ENTERPRISE_NOTICE_READ = [FUNCTION.ENTERPRISE_NOTIFICATION_LIST ,FUNCTION.ENTERPRISE_NOTIFICATION_DETAIL];
const ENTERPRISE_NOTICE_WRITE = [
  ...ENTERPRISE_NOTICE_READ,
  FUNCTION.ENTERPRISE_NOTIFICATION_REGISTER,
  FUNCTION.ENTERPRISE_NOTIFICATION_EDIT,
  FUNCTION.ENTERPRISE_NOTIFICATION_IMPORT
];

const SUPERUSER_ROLE_MANAGEMENT_READ = [
  FUNCTION.SUPERUSER_SERVICE_ROLE_LIST,
  FUNCTION.SUPERUSER_SERVICE_ROLE_DETAIL,
  FUNCTION.SUPERUSER_ENTERPRISE_ROLE_LIST,
  FUNCTION.SUPERUSER_ENTERPRISE_ROLE_DETAIL,
];

const SUPERUSER_ROLE_MANAGEMENT_WRITE = [
  ...SUPERUSER_ROLE_MANAGEMENT_READ,
  FUNCTION.SUPERUSER_SERVICE_ROLE_REGISTER,
  FUNCTION.SUPERUSER_SERVICE_ROLE_EDIT,
  FUNCTION.SUPERUSER_ENTERPRISE_ROLE_REGISTER,
  FUNCTION.SUPERUSER_ENTERPRISE_ROLE_EDIT,
];

const SUPERUSER_MANAGEMENT_READ = [FUNCTION.SUPERUSER_LIST, FUNCTION.SUPERUSER_DETAIL];
const SUPERUSER_MANAGEMENT_WRITE = [
  ...SUPERUSER_MANAGEMENT_READ,
  FUNCTION.SUPERUSER_REGISTER,
  FUNCTION.SUPERUSER_EDIT,
  FUNCTION.SUPERUSER_IMPORT,
];

const SERVICE_MANAGEMENT_READ = [
  FUNCTION.SERVICE_LIST,
  FUNCTION.SERVICE_DETAIL,
  FUNCTION.SERVICE_GROUP_LIST,
  FUNCTION.SERVICE_GROUP_DETAIL,
  FUNCTION.SERVICE_DETAIL_MENU_NONE,
];

const SERVICE_MANAGEMENT_WRITE = [
  ...SERVICE_MANAGEMENT_READ,
  FUNCTION.SERVICE_REGISTER,
  FUNCTION.SERVICE_EDIT,
  FUNCTION.SERVICE_IMPORT,
  FUNCTION.SERVICE_GROUP_REGISTER,
  FUNCTION.SERVICE_GROUP_EDIT,
];

const ENTERPRISE_PERFORMANCE_READ = [
  FUNCTION.SERVICE_RECORD_COMPANY_LIST,
  FUNCTION.SERVICE_RECORD_SERVICE_LIST,
  FUNCTION.SERVICE_RECORD_SERVICES_LIST, // Step 12.3.0 TAS-21359
];

const HIDDEN_STATUS_MANAGEMENT_MANUAL_DISPLAY = [
  FUNCTION.FAQ,
];

const HIDDEN_STATUS_MANAGEMENT_ALL_DISPLAY = [
  FUNCTION.CONTACT,
  FUNCTION.FAQ,
];

const SUPERUSER_TYPE_FUNCTION_AUTHORITY = {
  enterpriseManagementAuthority: {
    [READ]: ENTERPRISE_MANAGEMENT_READ,
    [WRITE]: ENTERPRISE_MANAGEMENT_WRITE,
  },
  enterpriseNoticeManagementAuthority: {
    [READ]: ENTERPRISE_NOTICE_READ,
    [WRITE]: ENTERPRISE_NOTICE_WRITE,
  },
  enterprisePerformanceManagementAuthority: {
    [READ]: ENTERPRISE_PERFORMANCE_READ,
  },
  serviceManagementAuthority: {
    [READ]: SERVICE_MANAGEMENT_READ,
    [WRITE]: SERVICE_MANAGEMENT_WRITE,
  },
  superuserManagementAuthority: {
    [READ]: SUPERUSER_MANAGEMENT_READ,
    [WRITE]: SUPERUSER_MANAGEMENT_WRITE,
  },
  superuserRoleManagementAuthority: {
    [READ]: SUPERUSER_ROLE_MANAGEMENT_READ,
    [WRITE]: SUPERUSER_ROLE_MANAGEMENT_WRITE,
  },
  hiddenStatusSetting: {
    [HIDDEN_STATUS.KNOWLEDGE_BASE]: HIDDEN_STATUS_MANAGEMENT_MANUAL_DISPLAY,
    [HIDDEN_STATUS.SHOW_ALL]: HIDDEN_STATUS_MANAGEMENT_ALL_DISPLAY,
  },
};

export default SUPERUSER_TYPE_FUNCTION_AUTHORITY;
